import type { OrganizationSettings, UpdateOrganizationInput } from '@chukua/common';
import { api } from '../../lib/api';

export type LogoVariant = 'light' | 'dark';

export function getCompanySettings(): Promise<OrganizationSettings> {
  return api<OrganizationSettings>('/organization/settings');
}

export function updateCompanySettings(input: UpdateOrganizationInput): Promise<OrganizationSettings> {
  return api<OrganizationSettings>('/organization/settings', { method: 'PATCH', body: JSON.stringify(input) });
}

export function uploadCompanyLogo(variant: LogoVariant, file: File): Promise<OrganizationSettings> {
  const body = new FormData();
  body.append('file', file);
  return api<OrganizationSettings>(`/organization/logo/${variant}`, { method: 'PUT', body });
}

export function removeCompanyLogo(variant: LogoVariant): Promise<OrganizationSettings> {
  return api<OrganizationSettings>(`/organization/logo/${variant}`, { method: 'DELETE' });
}
